module.exports = __webpack_public_path__ + "media/images/EMZ-34488d5c.png";